export const alphanumericPattern = /[^a-zA-Z0-9 ]/;               // accepts only alphanumeric and space
export const positiveNumberPattern = /^[1-9]\d*$/;               // accepts positive integers greater than 0